import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Button, Modal } from "semantic-ui-react";
import { Redirect, withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { jwtFetchData, jwtExpiredOrInvalid } from "../store/actions/JWTActions";
import { userHasErrored } from "../store/actions/UserActions";

import LoginForm from "../components/LoginForm";

class ReloginHOC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toLogin: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ReloginUser.id && this.props.ReloginUser.id) {
      if (prevProps.ReloginUser.id !== this.props.ReloginUser.id) {
        if (
          Object.entries(this.props.userReal).length !== 0 &&
          prevProps.ReloginUser.id === this.props.userReal.id
        ) {
          this.props.history.push("/init");
        } else {
          this.toLogin();
        }
      }
    }
  }

  toLogin() {
    clearInterval(this.props.intervalID);
    sessionStorage.removeItem("state");
    sessionStorage.removeItem("time");
    this.props.resetUserError(false);
    this.setState({ toLogin: true });
  }

  relogin(username, password) {
    this.props.fetchJWT(window.env.LoginURL, username, password, true);
  }

  render() {
    if (
      this.props.ReloginUser.active === false ||
      this.state.toLogin === true ||
      (!this.props.jwt && !sessionStorage.getItem("state"))
    ) {
      return <Redirect to="/login" />;
    } else {
      const message = {
        text: "Fill the form to relogin into the App",
        view: this.props.jwtHasErrored,
        header: "Welcome back to SimCAA"
      };

      const childrenWithExtraProp = React.Children.map(
        this.props.children,
        child => {
          const code = Math.random().toString(36).substring(7);
          const keyErorr = this.props.forceUpdate ? `error-${code}` : "error"
          const keyWorking = this.props.forceUpdate ? `working-${code}` : "working"
          return React.cloneElement(child, {
            key: this.props.jwtExpiredOrInvalid ? keyErorr : keyWorking
          });
        }
      );

      return (
        <div>
          <Modal open={this.props.jwtExpiredOrInvalid}>
            <Modal.Header>Session time out</Modal.Header>
            <Modal.Content>
              <LoginForm
                login={this.relogin.bind(this)}
                message={message}
                loading={this.props.jwtIsLoading}
              />
            </Modal.Content>
            <Modal.Actions>
              <Button negative onClick={this.toLogin.bind(this)}>
                Exit the app
              </Button>
            </Modal.Actions>
          </Modal>
          {childrenWithExtraProp}
        </div>
      );
    }
  }
}

ReloginHOC.propTypes = {
  forceUpdate: PropTypes.bool
}

ReloginHOC.defaultProps = {
  forceUpdate: false
}

const mapStateToProps = state => {
  return {
    jwt: state.jwt.jwt_token,
    jwtExpiredOrInvalid: state.jwtExpiredOrInvalid,
    jwtHasErrored: state.jwtHasErrored,
    jwtIsLoading: state.jwtIsLoading,
    ReloginUser: state.user,
    userReal: state.userReal,
    intervalID: state.refreshTokenIntervalID
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchJWT: (url, username, password, reLogin) =>
      dispatch(jwtFetchData(url, username, password, reLogin)),
    openModal: value => dispatch(jwtExpiredOrInvalid(value)),
    resetUserError: value => dispatch(userHasErrored(value))
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReloginHOC)
);



// WEBPACK FOOTER //
// ./src/HOC/ReloginHOC.js